export const IN_LAP = 'inLap';
export const IN_SEAT = 'inSeat';
